import type { AsyncData, AsyncDataOptions, KeysOf } from "#app/composables/asyncData";
import type { Strapi4ResponseMany } from "@nuxtjs/strapi/dist/runtime/types";

export const useCachedAsyncData = <ResT, DataE = Error, DataT = ResT, PickKeys extends KeysOf<DataT> = KeysOf<DataT>, DefaultT = null>(
    key: string,
    handler: () => Promise<Strapi4ResponseMany<DataT>>,
    options: AsyncDataOptions<DataT, any, KeysOf<any>, null> = {}
): AsyncData<Strapi4ResponseMany<DataT>, any> => {
    const { locale } = useI18n()
    return useAsyncData(
        `${key}-${locale.value}`,
        handler,
        {
            server: true,
            immediate: true,
            getCachedData: (key) => useNuxtData(key).data.value,
            ...options
        }
    )
}